/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Toast_Update_PxkInputs */

const vi_pll_toast_update_pxk = /** @type {(inputs: Pll_Toast_Update_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thay đổi phiếu xuất`)
};

/**

* @param {Pll_Toast_Update_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_toast_update_pxk = /** @type {((inputs?: Pll_Toast_Update_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Toast_Update_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_toast_update_pxk(inputs)
});